export default __webpack_public_path__ + "static/media/YP_COM_HEALTH.2577a013.png";